import React, { createContext, useContext, useState, useEffect } from 'react'
import ReactModal from 'react-modal'
import classNames from 'classnames'

import styles from './modal.module.sass'

export const ModalContext = createContext({})

// https://www.codementor.io/@sambhavgore/an-example-use-context-and-hooks-to-share-state-between-different-components-sgop6lnrd
export const ModalContextProvider = ({ children }) => {
  const [activeModal, setActiveModal] = useState(null)
  const [modalSets, setModalSets] = useState({})
  const addToModalSet = (setName, value) => {
    const currentSet = modalSets[setName] || []
    modalSets[setName] = Array.from(new Set([...currentSet, value]))
  }
  const cycleModalSet = (setName, value, offset) => {
    const arr = modalSets[setName] || []
    if (arr.length < 2) return undefined

    const i = arr.indexOf(value.toString())
    if (i === -1) return undefined

    return arr[(i + offset) % arr.length]
  }

  return <ModalContext.Provider value={{ activeModal, setActiveModal, addToModalSet, cycleModalSet }}>{children}</ModalContext.Provider>
}

// https://upmostly.com/tutorials/modal-components-react-custom-hooks
export const Modal = ({ setName, name, children, className }) => {
  const { activeModal, setActiveModal, cycleModalSet, addToModalSet } = useContext(ModalContext)
  const hide = () => setActiveModal(null)
  const prevName = cycleModalSet(setName, name, -1)
  const nextName = cycleModalSet(setName, name, 1)
  useEffect(() => {
    addToModalSet(setName, name)
  }, [setName])

  return (
    <>
      {activeModal === name && (
        <ReactModal
          overlayClassName={styles.modalOverlay}
          className={classNames(styles.modalContent, className)}
          // closeTimeoutMS={200}
          isOpen={activeModal === name}
          contentLabel="modal"
          onRequestClose={() => setActiveModal(null)}
          ariaHideApp={false}
        >
          {children}
          <button className={styles.closeButton} data-dismiss="modal" aria-label="Close" onClick={hide}>
            Close
          </button>
          {prevName && (
            <button className={styles.prevButton} onClick={() => setActiveModal(prevName)}>
              Prev
            </button>
          )}
          {nextName && (
            <button className={styles.nextButton} onClick={() => setActiveModal(nextName)}>
              Next
            </button>
          )}
        </ReactModal>
      )}
    </>
  )

  // <>
  //   <div className={styles.modalOverlay} onClick={hide} />
  //   <div className={styles.modalWrapper} aria-modal aria-hidden tabIndex={-1} role="dialog">
  //     <div className={styles.modal + ' ' + className}>
  //       {children}
  //       <button className={styles.closeButton} data-dismiss="modal" aria-label="Close" onClick={hide}>
  //         Close
  //       </button>
  //       {prevName && (
  //         <button className={styles.prevButton} onClick={() => setActiveModal(prevName)}>
  //           Prev
  //         </button>
  //       )}
  //       {nextName && (
  //         <button className={styles.nextButton} onClick={() => setActiveModal(nextName)}>
  //           Next
  //         </button>
  //       )}
  //     </div>
  //   </div>
  // </>
}
